import { isAxiosError } from "axios"
import { useEffect, useState } from "react"

import { api } from "~/shared/api"

let cache: any = undefined

export function useUserGroups() {
	const [state, setState] = useState<{
		contents: any
		state: "loading" | "hasError" | "loaded"
	}>(cache ?? { contents: undefined, state: "loading" })

	useEffect(() => {
		if (cache) return

		api.get("personal-office/main/userGroupList")
			.then((res) => {
				cache = { contents: res.data, state: "loaded" }
				setState(cache)
			})
			.catch((err) => {
				let errorMessage = ""

				if (isAxiosError(err)) {
					errorMessage =
						err?.response?.data.message ??
						err?.response?.data.error ??
						err.message
				} else if (err instanceof Error) {
					errorMessage = err.message
				} else {
					errorMessage = "Неизвестная ошибка!"
				}

				setState({ contents: errorMessage, state: "hasError" })
			})
	}, [])

	return state
}
